import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    DestroyRef,
    ElementRef,
    HostListener,
    inject,
    input,
    model,
    output,
    TemplateRef,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { TrgDragDirective } from '../../../../pbir/utils/TrgDrag.directive';
import { RichTextValue } from 'src/app/services/api.services';
import { TrgDrop } from 'src/app/pbir/utils/TrgDrop.directive';

@Component({
  selector: 'visual-editor-field',
  templateUrl: './Field.component.html',
  styleUrls: ['./Field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.visual-editor-field__filter-match]': 'filterMatch()'
  },
  standalone: false
})
export class VisualEditorFieldComponent {
  readonly destroyRef = inject(DestroyRef);

  readonly Display = VisualEditorField.Display;

  readonly busy = input(false);
  readonly display = input(VisualEditorField.Display.Placeholder);

  readonly icon = input('');
  readonly shortTitle = input('');
  readonly longTitle = input<string>(null);
  readonly description = input<RichTextValue>(null); // TODO: description
  readonly tooltip = input<RichTextValue>(null); // TODO: tooltip

  readonly isValid = input<boolean>(true);
  readonly error = input<string>(null);
  readonly title = computed(() => this.isValid() ? (this.longTitle() ?? this.shortTitle()) : this.error());
  
  readonly filterable = input(false, { transform: booleanAttribute });
  readonly filterPattern = input<RegExp>(null);
  readonly filterMatch = model<boolean>();

  readonly draggable = input(false, { transform: booleanAttribute });
  readonly dragDelay = input<number>(null);

  readonly dragging = output<boolean>();
  readonly enterDrop = output<TrgDrop.DropEvent>();
  readonly exitDrop = output<TrgDrop.DropEvent>();

  readonly dropData = input<any>(null);

  readonly dragPreviewSizeElement = viewChild.required<ElementRef<HTMLDivElement>>('sizing');
  readonly dragPreviewSize = () => {
    let el = this.dragPreviewSizeElement()?.nativeElement;
    if (!el) {
      return {
        width: '0px',
        height: '0px'
      };
    }

    let size = {
      width: `${Math.ceil(el.offsetWidth)}px`,
      height: `${Math.ceil(el.offsetHeight)}px`
    };

    return size;
  };

  readonly drawPreviewText = input<string>(null);

  readonly leftTemplate = input<TemplateRef<any>>(null);
  readonly rightTemplate = input<TemplateRef<any>>(null);
  readonly templateData = input<any>(null);

  onMouseDown(e: MouseEvent, drag: TrgDragDirective) {
    if (this.draggable())
      drag?.onMouseDown(e);
  }
}

export namespace VisualEditorField {
  export enum Display {
    Placeholder,
    Outline,
    Flat,
  }
}
